import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { showSplashScreen } from '../slices/ui.js'
import { setInfoPanel } from '../slices/ui'

import {
  useNavigatorOnline
} from '../hooks'

import { ACTIONS } from '../trans'

const ActionButton = (props) => {
  const { action, className } = props
  const dispach = useDispatch()
  const { isOnline } = useNavigatorOnline()

  useEffect(()=>{
    dispach(showSplashScreen(action.isLoading))
  }, [action.isLoading])

  const ButtonClassName = ['button', className, action.className || 'raised'].filter(x =>!!x).join(" ")

  return (
    <button className={ ButtonClassName }
      onClick={ action.onClick }
      disabled={ !isOnline || action.isLoading } >
      { action.icon }
      { action.text }
    </button>
  )
}

const Actions = (props) => {
  const { actions } = props
  if (!actions || actions.length == 0) return null
  return (
    <>
      <h3 className="pwa__infopanel__section__title pwa__infopanel__actions__title">
        {ACTIONS}
      </h3>
      { actions.map((action, key) => 
          (action.pinned) ? (
            <div key={key} className="pwa__infopanel__action pinned">
              <ActionButton action={action}/>
            </div>
          ) : (
            <div key={key} className="pwa__infopanel__action">
              <ActionButton action={action}/>
            </div>
          )
      )}
    </>
  )
}

export default Actions
